import { Component, DestroyRef, OnDestroy, inject } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { Observable, Subject, Subscription } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
    template: "",
})
export class BaseComponent {
    private destroyRef = inject(DestroyRef);

    private subscriptions: Subscription[] = [];

    subscribeToStore<T>(sub: Observable<T>, callback?: (a: T) => void) {
        this.subscriptions.push(
            sub.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((x) => {
                if (callback) {
                    callback(x);
                }
            }),
        );
    }
}
